import styled from "styled-components";
import { CLOSED_WIDTH, DEFAULT_EXTRA_MENU_WIDTH, OPEN_WIDTH } from "./Sidebar.constants.js";

type StyledSidebarOuterProps = {
    floating?: boolean;
    extraMenuWidth?: string;
    open?: boolean;
    zIndex?: number;
    backgroundColor?: string;
};

export const StyledSidebarOuter = styled.div<StyledSidebarOuterProps>`
    flex-shrink: 0;
    position: relative;
    background-color: ${({ backgroundColor }) => backgroundColor ?? "transparent"};
    height: 100%;
    max-height: 100%;
    display: flex;
    min-width: ${({ floating, extraMenuWidth = DEFAULT_EXTRA_MENU_WIDTH, open }) =>
        floating ? `calc(${CLOSED_WIDTH} + ${extraMenuWidth})` : `calc(${open ? OPEN_WIDTH : CLOSED_WIDTH} ${extraMenuWidth})`};
    max-width: ${({ floating, extraMenuWidth = DEFAULT_EXTRA_MENU_WIDTH, open }) =>
        floating ? `calc(${CLOSED_WIDTH} + ${extraMenuWidth})` : `calc(${open ? OPEN_WIDTH : CLOSED_WIDTH} ${extraMenuWidth})`};
    z-index: ${({ zIndex }) => zIndex};
`;

type StyledSidebarExtraMenuContainerProps = {
    floating?: boolean;
    visible?: boolean;
    maxWidth?: string;
};

export const StyledSidebarExtraMenuContainer = styled.div<StyledSidebarExtraMenuContainerProps>`
    padding: ${(props) => `${props.theme.spacing[48]} ${props.theme.spacing[16]}`};
    max-width: ${({ maxWidth }) => maxWidth || DEFAULT_EXTRA_MENU_WIDTH};
    flex-shrink: 0;
    border-right: 1px solid ${(props) => props.theme.grayscale.white};
    margin-left: ${({ floating }) => (floating ? CLOSED_WIDTH : "0")};
    display: ${({ visible }) => (visible ? "block" : "none")};
    > * {
        max-width: 100%;
    }
`;

export const StyledSidebarSectionsContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    margin-top: ${(props) => props.theme.spacing[32]};
`;
